import { InjectionToken } from '@angular/core';

export const LOC_PORTAL_TYPE = new InjectionToken<string>('forRoot() Portal Type for Localization');
